import React, { Component } from "react";
import { Link } from "react-router-dom";

class ClaimCreateSelectType extends Component {
  renderClaimType(title, desc, when, color, route) {
    return (
      <Link
        to={route}
        style={{
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          padding: 22,
          textDecoration: "none",
          color: "#0F172A",
          minHeight: 190,
          display: "block",
        }}
      >
        <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 18 }}>
          <div style={{ width: 54, height: 54, borderRadius: 14, background: color }} />
          <div>
            <div style={{ fontSize: 18, fontWeight: 900 }}>{title}</div>
            <div style={{ fontSize: 13, color: "#64748B", lineHeight: "20px", marginTop: 4 }}>{desc}</div>
          </div>
        </div>

        <div style={{ height: 1, background: "#E5E7EB", margin: "16px 0" }} />

        <div style={{ fontSize: 13, fontWeight: 900, color: "#0F766E", marginBottom: 8 }}>When to use:</div>
        <div style={{ fontSize: 13, color: "#64748B", lineHeight: "22px" }}>{when}</div>
      </Link>
    );
  }

  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>Create Claim</h4>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Step 1 of 4: Select the type of claim you want to create.
          </p>
        </div>

        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: 18, marginBottom: 20 }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 }}>
            {["Select Claim Type", "Claim Details", "Documents", "Review & Submit"].map((s, i) => (
              <div key={s} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    background: i === 0 ? "#DC111C" : "#F1F5F9",
                    color: i === 0 ? "#fff" : "#334155",
                    textAlign: "center",
                    lineHeight: "34px",
                    fontWeight: 900,
                  }}
                >
                  {i + 1}
                </div>
                <div>
                  <div style={{ fontWeight: 900, fontSize: 13 }}>{s}</div>
                  <div style={{ color: "#64748B", fontSize: 12 }}>
                    {i === 0 ? "Choose the type of claim" : "Provide information"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <input placeholder="Search claim types..." style={{ ...inputStyle, marginBottom: 18 }} />

            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18 }}>
              {this.renderClaimType("Cash Claim", "Claim cash expenses paid out of your own pocket.", "Use for any out-of-pocket expenses not covered by other claim types.", "#DCFCE7", "/claim/create/cash")}
              {this.renderClaimType("Credit Card Claim", "Claim expenses charged to your corporate credit card.", "Use for expenses paid using the corporate credit card.", "#DBEAFE", "/claim/create/credit-card")}
              {this.renderClaimType("Local Travel Claim", "Claim travel expenses for official trips within Malaysia.", "Use for business travel within Malaysia.", "#EDE9FE", "/claim/create/local-travel")}
              {this.renderClaimType("Overseas Travel Claim", "Claim travel expenses for official trips outside Malaysia.", "Use for business travel outside Malaysia.", "#F3E8FF", "/claim/create/overseas-travel")}
              {this.renderClaimType("Meal Allowance", "Claim meal allowance based on official travel schedules.", "Use for meal allowance during official travel as per policy.", "#FFEDD5", "/claim/create/meal")}
              {this.renderClaimType("Mileage Claim", "Claim mileage for using your personal vehicle.", "Use when you use your own vehicle for official duties.", "#CCFBF1", "/claim/create/mileage")}
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h5 style={sideTitle}>Claim Guidance</h5>
              <div style={sideText}>
                Required documents are typically needed for most claims:
                <ul>
                  <li>Original receipts / invoices</li>
                  <li>Proof of payment</li>
                  <li>Supporting documents</li>
                </ul>
              </div>
            </div>

            <div style={sideCard}>
              <h5 style={sideTitle}>Link to Records</h5>
              <p style={sideText}>Some claim types can be linked to existing Travel & Budget records.</p>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
          <button style={secondaryButton}>Save Draft</button>
          <button style={primaryButton}>Continue ›</button>
        </div>
      </div>
    );
  }
}

const inputStyle = {
  width: "100%",
  height: 42,
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "0 14px",
  fontSize: 13,
  outline: "none",
};

const sideCard = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 20,
  marginBottom: 16,
};

const sideTitle = {
  margin: "0 0 12px",
  fontWeight: 900,
  color: "#0F172A",
};

const sideText = {
  color: "#64748B",
  fontSize: 13,
  lineHeight: "22px",
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 22px",
  fontWeight: 900,
  cursor: "pointer",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
  cursor: "pointer",
};

export default ClaimCreateSelectType;